import type { SliderDesignTokens, SliderTokenSections } from '@primeuix/themes/types/slider';

export const root: SliderTokenSections.Root = {
    transitionDuration: '{transitionDuration}'
};

export const track: SliderTokenSections.Track = {
    background: '{content.borderColor}',
    borderRadius: '{content.borderRadius}',
    size: '3px'
};

export const range: SliderTokenSections.Range = {
    background: '{primary.color}'
};

export const handle: SliderTokenSections.Handle = {
    width: '20px',
    height: '20px',
    borderRadius: '{extend.borderRadius.rounded}',
    background: '{content.borderColor}',
    hoverBackground: '{content.borderColor}',
    content: {
        borderRadius: '{extend.borderRadius.rounded}',
        hoverBackground: '{content.background}',
        width: '16px',
        height: '16px',
        shadow: '{extend.shadowsm}'
    },
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export const colorScheme: SliderTokenSections.ColorScheme = {
    light: {
        handle: {
            content: {
                background: '{surface.0}'
            }
        }
    },
    dark: {
        handle: {
            content: {
                background: '{surface.950}'
            }
        }
    }
};

export default {
    root,
    track,
    range,
    handle,
    colorScheme
} satisfies SliderDesignTokens;
